import { EmptyState } from "@freightsimple/ui-core/Display/EmptyState";
import { SignpostIcon } from "@phosphor-icons/react/Signpost";
import type { CarrierRoute } from "@/App/carrierRoutes";
import { OperationalIssuesView } from "@/App/Views/OperationalIssuesView";
import { InvoiceAuditsView } from "@/App/Views/InvoiceAuditsView";
import { ShipmentsView } from "@/App/Views/ShipmentsView";
import { PerformanceView } from "@/App/Views/PerformanceView";
import { CustomerSpecificPricingView } from "@/App/Views/CustomerSpecificPricingView";
import { CustomerSpecificPricingDetailView } from "@/App/Views/CustomerSpecificPricingDetailView";
import { ShipmentPage } from "@/App/Shipment/ShipmentPage";
import { OpportunityPage } from "@/App/Opportunities/OpportunityPage";

/** Maps a parsed route to its view. */
export function CarrierRouter({ route }: { route: CarrierRoute }) {
  switch (route.kind) {
    case "operationalIssues":
      return <OperationalIssuesView />;
    case "shipments":
      return <ShipmentsView />;
    case "shipment":
      return <ShipmentPage shipmentId={route.shipmentId} />;
    case "invoiceAudits":
      return <InvoiceAuditsView />;
    case "performance":
      return <PerformanceView />;
    case "customerSpecificPricing":
      return <CustomerSpecificPricingView />;
    case "customerSpecificPricingAgreement":
      return (
        <CustomerSpecificPricingDetailView agreementId={route.agreementId} />
      );
    case "opportunity":
      return <OpportunityPage companyId={route.companyId} />;
    case "notFound":
      return (
        <EmptyState
          icon={SignpostIcon}
          title="Page not found"
          description="That link doesn't point anywhere in the carrier portal."
        />
      );
  }
}
